import React from 'react';
import TitleBanner from './TitleBanner';
import TestimonialServicesSection from './TestimonialServicesSection';
import ActivityCard from './ActivityCard';
import TestimonialsSlider from './TestimonialsSlider';
import ApplicationForm from './ApplicationForm';

const Community = () => {
    return(
        <div>
            <TitleBanner image="/Website_Title_Images/Community_Participation.svg" title={"Community Participation"} subheading={"Discover more limitless in what you do everyday"} />

            <div className="w-full px-4 md:px-36 text-gray-800 text-base md:text-lg py-4 md:py-6">
                <p className="my-4 md:my-6">
                    Individuals with a disability usually find it challenging to interact and engage in activities in a social setting. At Livability Care Australia, we understand how much community participation can change a person's well-being, and we constantly work towards establishing an environment that engages people and encourages them to interact more freely.
                </p>

                <p className="my-4 md:my-6">
                    We can help you to access and engage with your community, whether you want to further your goals and interests, work, study, or simply socialize. Our trusted team of support workers will transport and accompany you while you are out.
                </p>
            </div>


            <TestimonialServicesSection />
            <ActivityCard/>
            <div className="w-full py-8 md:py-12 flex justify-center px-4 md:px-0">
                <div className='max-w-3xl'>
                    <h1 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 text-primary font-arial-rounded">
                        How do I know I have access to Social and Community Participation?
                    </h1>
                    
                    <div className="space-y-4">
                        <p className="text-gray-800 text-lg md:text-xl">
                            We encourage participants seeking assistance with social and community participation to review their NDIS plan to check their eligibility and available supports. Your plan will outline the funded supports you're eligible for, including a section on <strong>Social and Community Participation</strong>. This category typically covers activities and supports that help you engage with the community, such as attending social events, joining clubs, or participating in group activities.
                            </p>
                            <p className="text-gray-800 text-lg md:text-xl">
                            If you're unsure whether Social and Community Participation is included in your plan, feel free to reach out to your <strong>Local Area Coordinator (LAC)</strong> or <strong>NDIS Planner</strong>. They can provide clear details about what's included and answer any questions you may have.
                            </p>


                        <p className="text-gray-800 text-base md:text-lg">
                        Additionally, our friendly team is here to help! We’re happy to guide you through your plan and assist with any inquiries you may have.
                        </p>
                    </div>
                </div>
            </div>
            <ApplicationForm/>
            <TestimonialsSlider />
        </div>
    )
}

export default Community;